import { useCallback, useState } from 'react';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { ApiService } from 'api';

const useSaveIdPMetadataUrl = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [errors, setErrors] = useState<string[] | null>(null);
  const saveIdPMetadataUrl = useCallback(
    async (url: string, firmId: number) => {
      try {
        await ApiService.apiSsoIntegrationsMetadataCreate({
          firm: firmId,
          metadata_url: url,
        });
      } catch (error) {
        const axiosError = error as AxiosError<any>;
        enqueueSnackbar('Error saving Identity Provider Metadata URL', { variant: 'error' });
        if (axiosError.response!.data.metadata_url) {
          setErrors(axiosError.response!.data.metadata_url);
        }
        throw error;
      }
    },
    [enqueueSnackbar]
  );
  return { saveIdPMetadataUrl, errors };
};

export default useSaveIdPMetadataUrl;
